<template>
  <router-view />
</template>

<script>

export default {
  name: "Management",
};
</script>
<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/content.scss";
@import "@/style/components/sidebar.scss";

</style>;
